import { blogCategoryLabels } from '@/content/blog-categories';
import type { PostMeta } from '@/lib/blog';
import { cn } from '@/lib/utils';
import { Clock } from 'lucide-react';
import Link from 'next/link';

interface BlogCardProps {
  post: PostMeta;
  className?: string;
}

export function BlogCard({ post, className }: BlogCardProps) {
  return (
    <Link
      href={`/blog/${post.slug}`}
      className={cn(
        'group flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-xs transition-all hover:-translate-y-1 hover:shadow-lg',
        className,
      )}
    >
      <img
        src={post.coverImage || '/images/placeholders/blog-cover-default.svg'}
        alt=""
        className="aspect-[1200/630] w-full object-cover"
        loading="lazy"
      />
      <div className="flex flex-1 flex-col gap-2 p-5">
        <span className="text-xs font-medium text-primary">
          {blogCategoryLabels[post.category]}
        </span>
        <h3 className="font-semibold text-foreground group-hover:text-primary">{post.title}</h3>
        <p className="line-clamp-2 text-sm text-muted-foreground">{post.excerpt}</p>
        <div className="mt-auto flex items-center gap-1.5 pt-2 text-xs text-muted-foreground">
          <Clock className="size-3.5" aria-hidden="true" />
          {post.readingTimeMinutes} min read
        </div>
      </div>
    </Link>
  );
}
